// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  REALTIME_DASHBOARD: '/realtime-dashboard',
  CONTENT_CHANNELS: '/engagement/apps',
  CONTENT_VIDEOS: '/engagement/videos',
  CONTENT_PLAYLISTS: '/engagement/playlists',
  SUBSCRIBERS: '/users/all',
  ADMIN_USERS: '/settings/access',
  SMTP_SETTINGS: '/settings/email',
  BILLING_SUBSCRIPTIONS: '/users/subscribers',
  BILLING_PAYMENTS: '/users/payments',
  REPORTS_OVERVIEW: '/reports/overview',
  REPORTS_LIVE_USERS: '/reports/live-users',
  REPORTS_SESSIONS: '/engagement/video-sessions',
  REPORTS_APP_SESSIONS: '/engagement/app-sessions',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
